import { Component } from '@angular/core';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';


@Component({
	selector: 'access-blocked',
	template: '<panel><h1>{{ \'general.access-denied\' | translate }}</h1> </panel>',
	imports: [Layout, TranslatePipe]
})
export class AccessBlockedComponent
{
	constructor() {

	}
}
